import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import type { ModifierFormItem } from "./ModifierForm"
import type {
    CategoryModifier,
    ModifierLocationSaveRequestData,
    ModifierSaveRequestData,
} from "../../../../graphql/types"

export const MODIFIER_FORM_SUBMITTED = "modifier/form/submitted"

export const modifierFormSubmitted = (oldValue: Maybe<ModifierFormItem>, newValue: ModifierFormItem) => ({
    type: MODIFIER_FORM_SUBMITTED,
    payload: {
        oldValue: oldValue,
        newValue: newValue,
    },
})

export const DELETE_MODIFIER_CLICKED = "modifier/delete/clicked"

export const deleteModifierClicked = (id: string) => ({
    type: DELETE_MODIFIER_CLICKED,
    payload: {
        modifierId: id,
    },
})

export const CLOSE_MODIFIER_FORM_CLICKED = "modifier/close/clicked"

export const closeModifierFormClicked = () => ({
    type: CLOSE_MODIFIER_FORM_CLICKED,
})
// Api actions

export const MODIFIER_SAVE_REQUESTED = "modifier/save/requested"

export const modifierSaveRequested = (data: ModifierSaveRequestData) => ({
    type: MODIFIER_SAVE_REQUESTED,
    payload: {
        data: data,
    },
})

export const MODIFIER_SAVE_SUCCESS = "modifier/save/success"

export const modifierSaveSuccess = (data: CategoryModifier) => ({
    type: MODIFIER_SAVE_SUCCESS,
    payload: {
        data: data,
    },
})

export const MODIFIER_SAVE_FAILURE = "modifier/save/failure"

export const modifierSaveFailure = (error: any) => ({
    type: MODIFIER_SAVE_FAILURE,
    payload: {
        error: error,
    },
})

export const MODIFIER_LOCATION_SAVE_REQUESTED = "modifier/location/save/requested"

export const modifierLocationSaveRequested = (data: ModifierLocationSaveRequestData, locationId: string) => ({
    type: MODIFIER_LOCATION_SAVE_REQUESTED,
    payload: {
        data: data,
        locationId: locationId,
    },
})

export const MODIFIER_LOCATION_SAVE_SUCCESS = "modifier/location/save/success"

export const modifierLocationSaveSuccess = (
    requestData: Maybe<ModifierLocationSaveRequestData>,
    locationId: string
) => ({
    type: MODIFIER_LOCATION_SAVE_SUCCESS,
    payload: {
        requestData: requestData,
        locationId: locationId,
    },
})

export const MODIFIER_LOCATION_SAVE_FAILURE = "modifier/location/save/failure"

export const modifierLocationSaveFailure = (error: any) => ({
    type: MODIFIER_LOCATION_SAVE_FAILURE,
    payload: {
        error: error,
    },
})

export const MODIFIERS_DELETED = "modifiers/deleted"
export const modifiersDeleted = (ids: string[]) => ({
    type: MODIFIERS_DELETED,
    payload: {
        ids: ids,
    },
})
